(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var DEBOUNCE_MS = 300;
    var debounceTimer = null;
    var requestToken = 0;

    function getSection() {
      return document.querySelector('[data-cart-section]');
    }

    function scheduleUpdate(key, quantity) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        updateCart(key, quantity);
      }, DEBOUNCE_MS);
    }

    function updateCart(key, quantity) {
      clearTimeout(debounceTimer);

      var section = getSection();
      if (!section) return;

      var changeUrl = section.getAttribute('data-cart-change-url');
      var sectionId = section.getAttribute('data-cart-section');
      var token = ++requestToken;

      section.classList.add('flamingo-cart--loading');

      fetch(changeUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity: quantity,
          sections: sectionId,
          sections_url: window.location.pathname
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart update failed');
          return response.json();
        })
        .then(function (state) {
          if (token !== requestToken) return;
          renderCart(state, sectionId);
          updateCartCount(state.item_count);
        })
        .catch(function (error) {
          console.error(error);
          window.location.reload();
        })
        .finally(function () {
          if (token === requestToken) {
            var current = getSection();
            if (current) current.classList.remove('flamingo-cart--loading');
          }
        });
    }

    function saveTradeIn(checked) {
      var section = getSection();
      var updateUrl = (section && section.getAttribute('data-cart-update-url')) || '/cart/update';

      fetch(updateUrl + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          attributes: { 'Trade-in pickup': checked ? 'Yes' : '' }
        })
      }).catch(function () {});
    }

    function renderCart(state, sectionId) {
      var html = state.sections && state.sections[sectionId];
      var currentRoot = document.querySelector('[data-cart-root]');

      if (!html || !currentRoot) {
        window.location.reload();
        return;
      }

      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var newRoot = parsed.querySelector('[data-cart-root]');

      if (!newRoot) {
        window.location.reload();
        return;
      }

      currentRoot.innerHTML = newRoot.innerHTML;
    }

    function updateCartCount(count) {
      var cartLink = document.querySelector('[data-cart-count]');
      if (!cartLink) return;

      var bubble = cartLink.querySelector('sup');

      if (count > 0) {
        if (!bubble) {
          bubble = document.createElement('sup');
          cartLink.insertBefore(bubble, cartLink.firstChild);
        }
        bubble.textContent = count;
      } else if (bubble) {
        bubble.remove();
      }
    }

    document.addEventListener('click', function (event) {
      var el = event.target;
      if (!el || typeof el.closest !== 'function') return;

      var stepper = el.closest('[data-cart-qty-minus], [data-cart-qty-plus]');
      var remove = el.closest('[data-cart-remove]');

      if (stepper) {
        var item = stepper.closest('[data-cart-line-key]');
        var control = stepper.closest('.flamingo-cart-item__quantity');
        if (!item || !control) return;

        var input = control.querySelector('[data-cart-qty-input]');
        if (!input) return;

        var current = parseInt(input.value, 10);
        if (isNaN(current)) current = 0;

        var isPlus = stepper.hasAttribute('data-cart-qty-plus');
        var next = isPlus ? current + 1 : Math.max(0, current - 1);

        input.value = next;
        scheduleUpdate(item.getAttribute('data-cart-line-key'), next);
        return;
      }

      if (remove) {
        event.preventDefault();
        var removeItem = remove.closest('[data-cart-line-key]');
        if (!removeItem) return;
        updateCart(removeItem.getAttribute('data-cart-line-key'), 0);
      }
    });

    document.addEventListener('change', function (event) {
      var el = event.target;
      if (!el || typeof el.closest !== 'function') return;

      var tradein = el.closest('[data-cart-tradein]');
      if (tradein) {
        saveTradeIn(tradein.checked);
        return;
      }

      var input = el.closest('[data-cart-qty-input]');
      if (!input) return;

      var item = input.closest('[data-cart-line-key]');
      if (!item) return;

      var value = parseInt(input.value, 10);
      if (isNaN(value) || value < 0) return;

      scheduleUpdate(item.getAttribute('data-cart-line-key'), value);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.flamingo-collection-filter[open]').forEach((details) => {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.flamingo-collection-filter[open]').forEach((details) => {
      details.removeAttribute('open');
      const summary = details.querySelector('summary');
      if (summary) summary.focus();
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flamingo-about-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-about-tiles]').forEach((viewport) => {
      const track = viewport.querySelector('[data-about-tiles-track]');
      if (!track || track.dataset.tilesReady === 'true') return;
      track.dataset.tilesReady = 'true';

      // Duplicate tiles once so the auto-scroll can loop seamlessly.
      const originals = Array.from(track.children);
      if (originals.length === 0) return;
      originals.forEach((node) => {
        const clone = node.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('id');
        track.appendChild(clone);
      });

      const SPEED = 0.5; // pixels per frame
      let paused = false;
      let rafId = null;

      const loopWidth = () => track.scrollWidth / 2;

      const step = () => {
        if (!paused) {
          viewport.scrollLeft += SPEED;
          if (viewport.scrollLeft >= loopWidth()) {
            viewport.scrollLeft -= loopWidth();
          }
        }
        rafId = requestAnimationFrame(step);
      };

      // Keep the scroll position within the first copy when the user swipes.
      viewport.addEventListener('scroll', () => {
        const w = loopWidth();
        if (viewport.scrollLeft >= w) {
          viewport.scrollLeft -= w;
        } else if (viewport.scrollLeft < 0) {
          viewport.scrollLeft += w;
        }
      });

      // Pause on hover only for devices that truly hover (desktop),
      // so touch devices keep auto-scrolling.
      const canHover = window.matchMedia('(hover: hover)').matches;
      if (canHover) {
        viewport.addEventListener('pointerenter', () => { paused = true; });
        viewport.addEventListener('pointerleave', () => {
          if (!viewport.classList.contains('is-dragging')) paused = false;
        });
      }

      // Drag to swipe with a pointer.
      let isDown = false;
      let startX = 0;
      let startScroll = 0;

      viewport.addEventListener('pointerdown', (e) => {
        isDown = true;
        paused = true;
        startX = e.clientX;
        startScroll = viewport.scrollLeft;
        viewport.classList.add('is-dragging');
        viewport.setPointerCapture(e.pointerId);
      });

      viewport.addEventListener('pointermove', (e) => {
        if (!isDown) return;
        viewport.scrollLeft = startScroll - (e.clientX - startX);
      });

      const endDrag = () => {
        if (!isDown) return;
        isDown = false;
        viewport.classList.remove('is-dragging');
        if (!canHover || !viewport.matches(':hover')) paused = false;
      };

      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);

      // Respect reduced motion preference.
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (reduce.matches) {
        paused = true;
      } else {
        rafId = requestAnimationFrame(step);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flamingo-category-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var SPEED = 0.5; // px per frame for the auto-slide

    function initGallery(viewport) {
      if (!viewport || viewport.dataset.galleryBound === '1') return;
      var track = viewport.querySelector('[data-marquee-track]');
      if (!track) return;
      var originals = Array.prototype.slice.call(track.children);
      if (originals.length === 0) return;

      viewport.dataset.galleryBound = '1';

      var half = 0; // width of one full set of cards (the loop period)
      var pos = 0;
      var paused = false;
      var dragging = false;
      var moved = false;
      var startX = 0;
      var startScroll = 0;
      var hovering = false;
      var resumeTimer = null;
      var resizeTimer = null;

      function wrap(value) {
        if (half <= 0) return value;
        value = value % half;
        if (value < 0) value += half;
        return value;
      }

      function appendSet() {
        originals.forEach(function (item) {
          var clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('data-gallery-clone', '');
          clone.setAttribute('tabindex', '-1');
          track.appendChild(clone);
        });
      }

      function buildClones() {
        track.querySelectorAll('[data-gallery-clone]').forEach(function (c) {
          c.remove();
        });

        appendSet();
        var firstClone = track.querySelector('[data-gallery-clone]');
        half = firstClone.offsetLeft - originals[0].offsetLeft;

        // Add more sets until the row is wide enough to cover the viewport
        // twice, so the seam where it loops is never visible as a gap.
        var guard = 0;
        while (track.scrollWidth < viewport.clientWidth * 2 + half && guard < 8) {
          appendSet();
          guard++;
        }

        pos = wrap(viewport.scrollLeft);
        viewport.scrollLeft = pos;
      }

      function step() {
        if (!track.isConnected) return;
        if (!paused && !dragging && !reduceMotion.matches) {
          pos = wrap(pos + SPEED);
          viewport.scrollLeft = pos;
        } else {
          pos = viewport.scrollLeft;
        }
        requestAnimationFrame(step);
      }

      // Pause on hover so the hover-expand interaction stays usable.
      viewport.addEventListener('mouseenter', function () {
        hovering = true;
        paused = true;
      });
      viewport.addEventListener('mouseleave', function () {
        hovering = false;
        if (!dragging) paused = false;
      });

      // Pause while a finger is down; resume shortly after so native
      // momentum scrolling can finish first.
      viewport.addEventListener(
        'touchstart',
        function () {
          if (resumeTimer) clearTimeout(resumeTimer);
          paused = true;
        },
        { passive: true }
      );
      viewport.addEventListener('touchend', function () {
        if (resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () {
          pos = wrap(viewport.scrollLeft);
          viewport.scrollLeft = pos;
          paused = false;
        }, 1400);
      });

      // Links/images drag natively by default, which hijacks the swipe before
      // it ever moves the row. Cancel that so dragging always scrolls instead.
      track.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });

      // Mouse drag to swipe on desktop.
      viewport.addEventListener('mousedown', function (e) {
        dragging = true;
        moved = false;
        startX = e.pageX;
        startScroll = viewport.scrollLeft;
        viewport.classList.add('is-dragging');
        e.preventDefault();
      });
      window.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        var dx = e.pageX - startX;
        if (Math.abs(dx) > 3) moved = true;
        pos = wrap(startScroll - dx);
        viewport.scrollLeft = pos;
      });
      window.addEventListener('mouseup', function () {
        if (!dragging) return;
        dragging = false;
        viewport.classList.remove('is-dragging');
        pos = viewport.scrollLeft;
        // Resume the auto-slide unless the cursor is still over the carousel.
        paused = hovering;
      });

      // Swallow the click that ends a drag so a card doesn't navigate.
      track.addEventListener(
        'click',
        function (e) {
          if (moved) {
            e.preventDefault();
            e.stopPropagation();
            moved = false;
          }
        },
        true
      );

      window.addEventListener('resize', function () {
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(buildClones, 200);
      });

      document.addEventListener('visibilitychange', function () {
        paused = document.hidden;
      });

      buildClones();
      requestAnimationFrame(step);
    }

    document
      .querySelectorAll('.flamingo-category-gallery [data-carousel-viewport]')
      .forEach(initGallery);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flamingo-faq"] && !Shopify.designMode) return;
  try {
    
  // Close other FAQ items in the same section when one opens (single-open behavior)
  document.querySelectorAll('.flamingo-faq').forEach((section) => {
    const items = Array.from(section.querySelectorAll('.flamingo-faq__item'));
    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        items.forEach((other) => {
          if (other !== item) other.removeAttribute('open');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flamingo-gallery"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-flamingo-gallery]').forEach((section) => {
    const items = Array.from(section.querySelectorAll('[data-gallery-item]'));
    const pageLinks = Array.from(section.querySelectorAll('[data-gallery-page]'));
    const nextButton = section.querySelector('[data-gallery-next]');
    if (!items.length || !pageLinks.length) return;

    const showPage = (pageNumber) => {
      items.forEach((item) => {
        item.hidden = Number(item.dataset.page) !== pageNumber;
      });

      pageLinks.forEach((link) => {
        const isCurrent = Number(link.dataset.galleryPage) === pageNumber;
        link.classList.toggle('flamingo-gallery__page-link--current', isCurrent);
        link.setAttribute('aria-current', isCurrent ? 'page' : 'false');
      });

      if (nextButton) {
        nextButton.hidden = pageNumber >= pageLinks.length;
      }
    };

    pageLinks.forEach((link) => {
      link.addEventListener('click', () => {
        showPage(Number(link.dataset.galleryPage));
      });
    });

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        const current = pageLinks.find((link) => link.classList.contains('flamingo-gallery__page-link--current'));
        const currentPage = current ? Number(current.dataset.galleryPage) : 1;
        if (currentPage < pageLinks.length) {
          showPage(currentPage + 1);
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flamingo-journals"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var stacks = document.querySelectorAll('[data-journal-stack]');

    stacks.forEach(function (stack) {
      stack.addEventListener(
        'wheel',
        function (event) {
          var canScroll = stack.scrollHeight > stack.clientHeight;

          if (!canScroll) return;

          var maxScroll = Math.max(0, stack.scrollHeight - stack.clientHeight);
          var atTop = stack.scrollTop <= 1;
          var atBottom = maxScroll - stack.scrollTop <= 1;

          if ((event.deltaY < 0 && atTop) || (event.deltaY > 0 && atBottom)) return;

          event.preventDefault();
          event.stopPropagation();
          stack.scrollTop = Math.max(0, Math.min(maxScroll, stack.scrollTop + event.deltaY));
        },
        { passive: false }
      );
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flamingo-kensho-ar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-kensho-section]');
    if (!section) return;

    var viewer = section.querySelector('[data-kensho-viewer]');
    var stage = section.querySelector('[data-kensho-stage]');
    var camera = section.querySelector('[data-kensho-camera]');
    var room = section.querySelector('[data-kensho-room]');
    var piece = section.querySelector('[data-kensho-piece]');
    var hint = section.querySelector('[data-kensho-hint]');
    var viewerTitle = section.querySelector('[data-kensho-viewer-title]');
    var closeBtn = section.querySelector('[data-kensho-close]');
    var upload = section.querySelector('[data-kensho-upload]');
    var scaleInput = section.querySelector('[data-kensho-scale]');

    var modelWrap = section.querySelector('[data-kensho-model-wrap]');
    var modelViewerLoading = null;

    var cameraStream = null;
    var posX = 0;
    var posY = 0;
    var scale = 0.8;
    var pointers = {};
    var pointerCount = 0;
    var dragStartX = 0;
    var dragStartY = 0;
    var pieceStartX = 0;
    var pieceStartY = 0;
    var pinchStartDist = 0;
    var pinchStartScale = 0.8;
    var hintTimer = null;

    function applyTransform() {
      piece.style.transform = 'translate(' + posX + 'px, ' + posY + 'px) scale(' + scale + ')';
    }

    function centerPiece() {
      var stageRect = stage.getBoundingClientRect();
      posX = stageRect.width * 0.5 - piece.offsetWidth * 0.5;
      posY = stageRect.height * 0.55 - piece.offsetHeight * 0.5;
      applyTransform();
    }

    function stopCamera() {
      if (!cameraStream) return;
      cameraStream.getTracks().forEach(function (track) { track.stop(); });
      cameraStream = null;
      camera.srcObject = null;
    }

    function startCamera() {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        camera.hidden = true;
        return;
      }

      navigator.mediaDevices
        .getUserMedia({ video: { facingMode: 'environment' }, audio: false })
        .then(function (stream) {
          cameraStream = stream;
          camera.srcObject = stream;
          camera.hidden = false;
          room.hidden = true;
        })
        .catch(function () {
          camera.hidden = true;
        });
    }

    function loadModelViewerScript() {
      if (window.customElements && window.customElements.get('model-viewer')) {
        return Promise.resolve();
      }
      if (modelViewerLoading) return modelViewerLoading;
      modelViewerLoading = new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.type = 'module';
        script.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js';
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
      return modelViewerLoading;
    }

    function openModelViewer(button) {
      viewer.classList.add('flamingo-kensho__viewer--model');
      modelWrap.hidden = false;

      var glb = button.getAttribute('data-kensho-glb');
      var usdz = button.getAttribute('data-kensho-usdz');
      var poster = button.getAttribute('data-kensho-image');
      var title = button.getAttribute('data-kensho-title') || '';

      loadModelViewerScript().then(function () {
        modelWrap.innerHTML = '';
        var mv = document.createElement('model-viewer');
        mv.setAttribute('src', glb);
        if (usdz) mv.setAttribute('ios-src', usdz);
        if (poster) mv.setAttribute('poster', poster);
        mv.setAttribute('alt', 'A 3D model of ' + title);
        mv.setAttribute('camera-controls', '');
        mv.setAttribute('auto-rotate', '');
        mv.setAttribute('touch-action', 'pan-y');
        mv.setAttribute('shadow-intensity', '1');
        mv.setAttribute('exposure', '1.05');
        mv.setAttribute('ar', '');
        mv.setAttribute('ar-modes', 'webxr scene-viewer quick-look');
        mv.setAttribute('ar-scale', 'fixed');

        var arButton = document.createElement('button');
        arButton.setAttribute('slot', 'ar-button');
        arButton.className = 'flamingo-kensho__ar-launch';
        arButton.textContent = section.getAttribute('data-kensho-ar-label') || 'View in AR';
        mv.appendChild(arButton);

        modelWrap.appendChild(mv);
      }).catch(function () {
        viewer.classList.remove('flamingo-kensho__viewer--model');
        modelWrap.hidden = true;
        openRoomPreview(button);
      });
    }

    function openRoomPreview(button) {
      piece.src = button.getAttribute('data-kensho-image') || '';

      scale = 0.8;
      scaleInput.value = 80;
      room.hidden = true;

      if (piece.complete) {
        centerPiece();
      } else {
        piece.onload = centerPiece;
      }

      startCamera();

      hint.style.opacity = 1;
      clearTimeout(hintTimer);
      hintTimer = setTimeout(function () { hint.style.opacity = 0; }, 5200);
    }

    function openViewer(button) {
      viewer.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      viewerTitle.textContent = button.getAttribute('data-kensho-title') || '';

      if (button.getAttribute('data-kensho-glb')) {
        openModelViewer(button);
      } else {
        openRoomPreview(button);
      }
    }

    function closeViewer() {
      viewer.hidden = true;
      viewer.classList.remove('flamingo-kensho__viewer--model');
      document.documentElement.style.overflow = '';
      stopCamera();
      room.hidden = true;
      room.removeAttribute('src');
      upload.value = '';
      modelWrap.hidden = true;
      modelWrap.innerHTML = '';
    }

    section.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      var openButton = target.closest('[data-kensho-open]');
      if (openButton) openViewer(openButton);
    });

    closeBtn.addEventListener('click', closeViewer);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !viewer.hidden) closeViewer();
    });

    upload.addEventListener('change', function () {
      var file = upload.files && upload.files[0];
      if (!file) return;
      var reader = new FileReader();
      reader.onload = function () {
        room.src = reader.result;
        room.hidden = false;
        stopCamera();
        camera.hidden = true;
      };
      reader.readAsDataURL(file);
    });

    scaleInput.addEventListener('input', function () {
      scale = Number(scaleInput.value) / 100;
      applyTransform();
    });

    function pointerDistance() {
      var ids = Object.keys(pointers);
      if (ids.length < 2) return 0;
      var a = pointers[ids[0]];
      var b = pointers[ids[1]];
      var dx = a.x - b.x;
      var dy = a.y - b.y;
      return Math.sqrt(dx * dx + dy * dy);
    }

    stage.addEventListener('pointerdown', function (event) {
      pointers[event.pointerId] = { x: event.clientX, y: event.clientY };
      pointerCount = Object.keys(pointers).length;
      stage.setPointerCapture(event.pointerId);

      if (pointerCount === 1) {
        dragStartX = event.clientX;
        dragStartY = event.clientY;
        pieceStartX = posX;
        pieceStartY = posY;
      } else if (pointerCount === 2) {
        pinchStartDist = pointerDistance();
        pinchStartScale = scale;
      }
    });

    stage.addEventListener('pointermove', function (event) {
      if (!pointers[event.pointerId]) return;
      pointers[event.pointerId] = { x: event.clientX, y: event.clientY };

      if (pointerCount === 1) {
        posX = pieceStartX + (event.clientX - dragStartX);
        posY = pieceStartY + (event.clientY - dragStartY);
        applyTransform();
      } else if (pointerCount === 2 && pinchStartDist > 0) {
        var nextScale = pinchStartScale * (pointerDistance() / pinchStartDist);
        scale = Math.min(1.6, Math.max(0.25, nextScale));
        scaleInput.value = Math.round(scale * 100);
        applyTransform();
      }
    });

    function releasePointer(event) {
      delete pointers[event.pointerId];
      pointerCount = Object.keys(pointers).length;
      if (pointerCount === 1) {
        var ids = Object.keys(pointers);
        dragStartX = pointers[ids[0]].x;
        dragStartY = pointers[ids[0]].y;
        pieceStartX = posX;
        pieceStartY = posY;
      }
    }

    stage.addEventListener('pointerup', releasePointer);
    stage.addEventListener('pointercancel', releasePointer);

    stage.addEventListener('wheel', function (event) {
      if (viewer.hidden) return;
      event.preventDefault();
      var direction = event.deltaY > 0 ? -0.05 : 0.05;
      scale = Math.min(1.6, Math.max(0.25, scale + direction));
      scaleInput.value = Math.round(scale * 100);
      applyTransform();
    }, { passive: false });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flamingo-living-room"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SPEED = 0.6; // px per frame for the auto-advance

    function initInfinite(viewport) {
      if (!viewport || viewport.dataset.carouselBound === '1') return;
      var track = viewport.querySelector('.flamingo-bundle__track');
      if (!track) return;

      var slides = Array.prototype.slice.call(track.children).filter(function (el) {
        return el.classList.contains('flamingo-bundle__slide');
      });
      if (slides.length === 0) return;

      viewport.dataset.carouselBound = '1';

      // Duplicate the slides once so the row can loop seamlessly.
      slides.forEach(function (slide) {
        var clone = slide.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a').forEach(function (a) {
          a.setAttribute('tabindex', '-1');
        });
        track.appendChild(clone);
      });

      var halfWidth = 0;
      function measure() {
        halfWidth = track.scrollWidth / 2;
      }
      measure();

      var resizeRaf = null;
      window.addEventListener('resize', function () {
        if (resizeRaf) cancelAnimationFrame(resizeRaf);
        resizeRaf = requestAnimationFrame(measure);
      });

      function normalize() {
        if (halfWidth <= 0) return;
        if (viewport.scrollLeft >= halfWidth) {
          viewport.scrollLeft -= halfWidth;
        } else if (viewport.scrollLeft <= 0) {
          viewport.scrollLeft += halfWidth;
        }
      }

      var paused = false;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function tick() {
        if (!viewport.isConnected) return;
        if (!paused) {
          viewport.scrollLeft += SPEED;
          normalize();
        }
        requestAnimationFrame(tick);
      }

      // Pointer drag (desktop) — scrolls manually and pauses the auto-advance.
      var isDown = false;
      var startX = 0;
      var startScroll = 0;
      var moved = false;

      viewport.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        isDown = true;
        moved = false;
        paused = true;
        startX = e.clientX;
        startScroll = viewport.scrollLeft;
        viewport.classList.add('is-dragging');
      });
      window.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 3) moved = true;
        viewport.scrollLeft = startScroll - dx;
        normalize();
      });
      window.addEventListener('pointerup', function () {
        if (!isDown) return;
        isDown = false;
        paused = false;
        viewport.classList.remove('is-dragging');
      });
      viewport.addEventListener('click', function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      }, true);

      // Pause on hover and while touching, keep wrapping during native scroll.
      viewport.addEventListener('mouseenter', function () {
        paused = true;
      });
      viewport.addEventListener('mouseleave', function () {
        if (!isDown) paused = false;
      });
      viewport.addEventListener('touchstart', function () {
        paused = true;
      }, { passive: true });
      viewport.addEventListener('touchend', function () {
        paused = false;
      });
      viewport.addEventListener('scroll', normalize, { passive: true });

      if (!reduceMotion) requestAnimationFrame(tick);
    }

    document.querySelectorAll('.flamingo-bundle [data-carousel-viewport]').forEach(initInfinite);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flamingo-lp-buybox"]) return;
  try {
    
  (function () {
    function init() {
      var panel = document.querySelector('[data-lp-buybox]');
      var info = document.querySelector('.flamingo-pdp__info');
      if (panel && info && !info.contains(panel)) {
        info.appendChild(panel);
      }

      // Wide screens: the left column ends after the description while the right one
      // runs long, so the Added Service block is moved across to balance them.
      var combos = document.querySelector('.flamingo-pdp__combos');
      var bodyMain = document.querySelector('.flamingo-pdp__body-main');
      if (combos && bodyMain && !bodyMain.contains(combos) && window.matchMedia('(min-width: 1000px)').matches) {
        bodyMain.appendChild(combos);
        combos.classList.add('tfl-combos-moved');
      }

      var bar = document.querySelector('[data-lp-buybar]');
      var actions = document.querySelector('.flamingo-pdp__actions');
      if (!bar || !actions || bar.dataset.lpReady) return;
      bar.dataset.lpReady = 'true';

      var trigger = bar.querySelector('[data-lp-buybar-btn]');
      trigger.addEventListener('click', function () {
        var buy = document.querySelector('#flo-buy-now-button, .flamingo-pdp__btn--buy');
        if (buy) {
          buy.click();
        } else {
          actions.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });

      if (!('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        bar.hidden = visible;
        document.body.classList.toggle('tfl-buybar-on', !visible);
      }, { threshold: 0.2 }).observe(actions);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flamingo-lp-delivery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function arm(root) {
      if (root.dataset.lpReady) return;
      root.dataset.lpReady = 'true';
      if (!('IntersectionObserver' in window)) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      root.classList.add('tfl-del--anim');
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            root.classList.add('is-inview');
            observer.disconnect();
          }
        });
      }, { threshold: 0.25 });
      observer.observe(root);
    }

    function armAll() {
      document.querySelectorAll('[data-lp-delivery]').forEach(arm);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', armAll);
    } else {
      armAll();
    }
    document.addEventListener('shopify:section:load', armAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flamingo-lp-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.lpReady) return;
      root.dataset.lpReady = 'true';

      var track = root.querySelector('[data-lp-track]');
      var slides = root.querySelectorAll('[data-lp-slide]');
      var dots = root.querySelectorAll('[data-lp-dot]');
      var count = slides.length;
      if (!track || count < 2) return;

      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var timer = null;

      function current() {
        return Math.round(track.scrollLeft / track.clientWidth);
      }

      function go(index) {
        var i = (index + count) % count;
        track.scrollTo({ left: i * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
      }

      function sync() {
        var i = current();
        dots.forEach(function (dot, n) {
          if (n === i) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      function stop() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(sync);
      }, { passive: true });

      dots.forEach(function (dot, n) {
        dot.addEventListener('click', function () {
          stop();
          go(n);
        });
      });

      var prev = root.querySelector('[data-lp-prev]');
      var next = root.querySelector('[data-lp-next]');
      if (prev) prev.addEventListener('click', function () { stop(); go(current() - 1); });
      if (next) next.addEventListener('click', function () { stop(); go(current() + 1); });

      track.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') { event.preventDefault(); stop(); go(current() + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); stop(); go(current() - 1); }
      });

      ['pointerdown', 'touchstart', 'wheel', 'focusin'].forEach(function (name) {
        root.addEventListener(name, stop, { passive: true });
      });

      var seconds = parseInt(root.dataset.autoplay, 10);
      if (!reduced && seconds > 0) {
        timer = setInterval(function () {
          if (document.hidden) return;
          go(current() + 1);
        }, seconds * 1000);
      }
    }

    function initAll() {
      document.querySelectorAll('[data-lp-hero]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flamingo-product-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MOBILE_QUERY = window.matchMedia('(max-width: 1024px), (pointer: coarse)');
    var engines = typeof WeakMap !== 'undefined' ? new WeakMap() : null;

    function smoothstep(t) {
      if (t <= 0) return 0;
      if (t >= 1) return 1;
      return t * t * (3 - 2 * t);
    }

    function teardownDesktop(section) {
      var engine = engines ? engines.get(section) : null;
      if (!engine) return;

      engine.running = false;
      if (engine.rafId) cancelAnimationFrame(engine.rafId);
      if (engine.onResize) window.removeEventListener('resize', engine.onResize);
      if (engine.resumeTimer) clearTimeout(engine.resumeTimer);

      var track = section.querySelector('[data-carousel-track]');
      if (!track) {
        if (engines) engines.delete(section);
        return;
      }

      track.classList.remove('is-ready', 'is-hovering');
      track.querySelectorAll('[data-carousel-clone]').forEach(function (clone) {
        clone.remove();
      });
      track.querySelectorAll('[data-carousel-card]').forEach(function (card) {
        card.style.left = '';
        card.style.width = '';
        card.classList.remove('is-featured');
      });

      if (engines) engines.delete(section);
    }

    function initDesktop(section, viewport, track, cards) {
      teardownDesktop(section);

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var inset;
      var gap;
      var Ws;
      var mediaH;
      var Xfeatured;
      var falloff;
      var N;
      var order = [];
      var leftPos = [];
      var leadX = 0;
      var feature = [];
      var speed = 0.6;
      var paused = false;
      var hovered = -1;
      var HOVER_GROW = 1.18;
      var engineState = { running: true, rafId: null, onResize: null, resumeTimer: null };

      function computeGeometry() {
        var vw = viewport.clientWidth;
        gap = 16;
        inset = Math.max(16, Math.min(vw * 0.034, 49));
        Ws = Math.min(vw * 0.28, 380);
        Xfeatured = inset + 2 * (Ws + gap);
        mediaH = Math.min(Ws * 1.2, 520);
        falloff = Ws + gap;

        section.style.setProperty('--carousel-media-height', mediaH + 'px');
        track.style.setProperty('--carousel-track-height', (mediaH + 100) + 'px');
      }

      function featureAt(x) {
        return smoothstep(1 - Math.abs(x - Xfeatured) / falloff);
      }

      function resetLayout() {
        order = [];
        var x = inset;
        for (var k = 0; k < N; k++) {
          order.push(k);
          leftPos[k] = x;
          feature[k] = featureAt(x);
          x += Ws + gap;
        }
        leadX = inset;
      }

      function render() {
        for (var k = 0; k < N; k++) {
          feature[k] = featureAt(leftPos[k]);
        }

        var x = leadX;
        for (var o = 0; o < order.length; o++) {
          var idx = order[o];
          var f = feature[idx];
          var w = idx === hovered ? Ws * HOVER_GROW : Ws;
          var card = cards[idx];
          card.style.left = x + 'px';
          card.style.width = w + 'px';
          card.style.setProperty('--feature', f.toFixed(3));
          card.classList.toggle('is-featured', f > 0.5);
          leftPos[idx] = x;
          x += w + gap;
        }

        var firstIdx = order[0];
        var firstW = firstIdx === hovered ? Ws * HOVER_GROW : Ws;
        if (leftPos[firstIdx] + firstW < -120) {
          order.shift();
          order.push(firstIdx);
          leadX += firstW + gap;
        }
      }

      function tick() {
        if (!track.isConnected || !engineState.running) return;
        if (!paused) {
          leadX -= speed;
          render();
        }
        engineState.rafId = requestAnimationFrame(tick);
      }

      function ensureEnoughCards() {
        var originalCount = cards.length;
        var maxViewport = window.screen && window.screen.width ? window.screen.width : viewport.clientWidth;
        var need = 2 * maxViewport + 800;
        var span = cards.length * (Ws + gap);
        var i = 0;

        while (span < need && cards.length < 60) {
          var clone = cards[i % originalCount].cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('data-carousel-clone', '');
          clone.querySelectorAll('[data-product-add]').forEach(function (btn) {
            btn.removeAttribute('data-product-add');
          });
          clone.querySelectorAll('a, button').forEach(function (el) {
            el.setAttribute('tabindex', '-1');
          });
          track.appendChild(clone);
          cards.push(clone);
          span += Ws + gap;
          i++;
        }
      }

      function setup() {
        computeGeometry();
        ensureEnoughCards();
        N = cards.length;
        track.classList.add('is-ready');
        resetLayout();
        render();
      }

      function setHovered(idx) {
        if (hovered === idx) return;
        hovered = idx;
        render();
      }

      setup();

      var resizeRaf = null;
      function onResize() {
        if (!track.isConnected) {
          window.removeEventListener('resize', onResize);
          return;
        }
        if (resizeRaf) cancelAnimationFrame(resizeRaf);
        resizeRaf = requestAnimationFrame(function () {
          computeGeometry();
          resetLayout();
          render();
        });
      }
      engineState.onResize = onResize;
      window.addEventListener('resize', onResize);

      function onViewportEnter() {
        if (engineState.resumeTimer) {
          clearTimeout(engineState.resumeTimer);
          engineState.resumeTimer = null;
        }
        paused = true;
        track.classList.add('is-hovering');
      }

      function onViewportLeave() {
        setHovered(-1);
        engineState.resumeTimer = setTimeout(function () {
          track.classList.remove('is-hovering');
          paused = false;
          engineState.resumeTimer = null;
        }, 360);
      }

      cards.forEach(function (card, i) {
        card.addEventListener('mouseenter', function () {
          setHovered(i);
        });
      });

      viewport.addEventListener('mouseenter', onViewportEnter);
      viewport.addEventListener('mouseleave', onViewportLeave);

      if (!reduceMotion) engineState.rafId = requestAnimationFrame(tick);

      if (engines) engines.set(section, engineState);
    }

    function initCarousel(section) {
      var viewport = section.querySelector('[data-carousel-viewport]');
      var track = section.querySelector('[data-carousel-track]');
      if (!viewport || !track) return;

      teardownDesktop(section);

      var cards = Array.prototype.slice.call(track.querySelectorAll('[data-carousel-card]'));
      if (cards.length === 0) return;

      track.dataset.carouselBound = '1';
      track.dataset.carouselMode = MOBILE_QUERY.matches ? 'mobile' : 'desktop';

      if (MOBILE_QUERY.matches) {
        track.classList.remove('is-ready', 'is-hovering');
        return;
      }

      initDesktop(section, viewport, track, cards);
    }

    function reinitAll() {
      document.querySelectorAll('.flamingo-product-carousel').forEach(function (section) {
        var track = section.querySelector('[data-carousel-track]');
        if (!track) return;
        delete track.dataset.carouselBound;
        initCarousel(section);
      });
    }

    document.querySelectorAll('.flamingo-product-carousel').forEach(initCarousel);

    if (typeof MOBILE_QUERY.addEventListener === 'function') {
      MOBILE_QUERY.addEventListener('change', reinitAll);
    } else if (typeof MOBILE_QUERY.addListener === 'function') {
      MOBILE_QUERY.addListener(reinitAll);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    var root = document.documentElement;
    var footer = document.querySelector('.flamingo-footer');
    var shell = document.querySelector('[data-page-shell]');
    if (!footer || !shell) return;

    function update() {
      // Measure the footer's natural height (it keeps its height when fixed).
      var footerH = footer.offsetHeight;
      // Only enable the reveal when the whole footer fits in the viewport;
      // otherwise the fixed footer's top would be clipped.
      if (footerH > 0 && footerH <= window.innerHeight) {
        root.style.setProperty('--flamingo-footer-reveal-height', footerH + 'px');
        root.classList.add('flamingo-shutter-active');
      } else {
        root.classList.remove('flamingo-shutter-active');
        root.style.removeProperty('--flamingo-footer-reveal-height');
      }
    }

    update();

    var raf = null;
    window.addEventListener('resize', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    });

    // Re-measure once fonts/images settle so the height is accurate.
    window.addEventListener('load', update);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const header = document.querySelector('.flamingo-header');
  const toggle = header && header.querySelector('.flamingo-header__toggle');
  const dropdowns = header ? Array.from(header.querySelectorAll('[data-header-dropdown]')) : [];
  const searchToggle = header && header.querySelector('[data-search-toggle]');
  const searchPanel = header && header.querySelector('[data-header-search]');
  const searchBackdrop = header && header.querySelector('[data-search-backdrop]');
  const searchInput = header && header.querySelector('[data-search-input]');
  const searchClear = header && header.querySelector('[data-search-clear]');
  const searchResults = header && header.querySelector('[data-search-results]');
  const searchHint = header && header.querySelector('[data-search-hint]');

  let searchAbortController = null;
  let searchDebounceTimer = null;
  let activeSuggestRequest = 0;

  const closeDropdowns = (activeDropdown = null) => {
    dropdowns.forEach((dropdown) => {
      if (dropdown !== activeDropdown) dropdown.removeAttribute('open');
    });
  };

  const escapeHtml = (value) =>
    String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

  const formatMoney = (amountValue, format) => {
    if (amountValue == null || amountValue === '') return '';

    // Predictive Search returns major currency units (DECIMAL), not cents.
    const amountNumber = Number(amountValue);
    if (Number.isNaN(amountNumber)) return '';

    const withSeparators = (value, decimals) => {
      const fixed = value.toFixed(decimals);
      const parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    };

    const amount = withSeparators(amountNumber, 2);
    const amountNoDecimals = withSeparators(amountNumber, 0);
    const amountWithComma = amount.replace(/,/g, 'X').replace('.', ',').replace(/X/g, '.');
    // Avoid Liquid-like money placeholders as string literals inside javascript tags.
    const formatString = format || ('Rs. {' + '{' + 'amount' + '}' + '}');

    return formatString
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals.replace(/,/g, '.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace('₹', 'Rs.')
      .replace('&#8377;', 'Rs.')
      .replace(/RS\s?/i, 'Rs. ')
      .replace(/<\/?[^>]+>/g, '')
      .trim();
  };

  const updateClearVisibility = () => {
    if (!searchClear || !searchInput) return;
    searchClear.hidden = searchInput.value.trim().length === 0;
  };

  const clearSearchResults = () => {
    if (searchResults) {
      searchResults.innerHTML = '';
      searchResults.hidden = true;
    }

    if (searchHint) searchHint.hidden = false;
  };

  const resetSearchPanel = () => {
    if (searchInput) searchInput.value = '';
    updateClearVisibility();
    clearSearchResults();
  };

  const getSearchPageUrl = (query) => {
    if (!searchPanel) return '/search';
    const base = searchPanel.dataset.searchUrl || '/search';
    const url = new URL(base, window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');
    return `${url.pathname}${url.search}`;
  };

  const renderPredictiveResults = (data, query) => {
    if (!searchPanel || !searchResults) return;

    const results = (data && data.resources && data.resources.results) || {};
    const queries = results.queries || [];
    const products = results.products || [];
    const moneyFormat = searchPanel.dataset.moneyFormat || '';
    const noResultsLabel = searchPanel.dataset.noResults || 'No matches found';
    const suggestionsLabel = searchPanel.dataset.suggestionsLabel || 'Suggestions';
    const productsLabel = searchPanel.dataset.productsLabel || 'Products';
    const viewAllLabel = searchPanel.dataset.viewAllLabel || 'View all';

    if (!queries.length && !products.length) {
      searchResults.innerHTML = `<p class="flamingo-header__search-empty">${escapeHtml(noResultsLabel)}</p>`;
      searchResults.hidden = false;
      if (searchHint) searchHint.hidden = true;
      return;
    }

    let html = '';

    if (queries.length) {
      html += `<div class="flamingo-header__search-group">`;
      html += `<p class="flamingo-header__search-group-title">${escapeHtml(suggestionsLabel)}</p>`;
      html += `<ul class="flamingo-header__search-suggestions">`;
      queries.slice(0, 4).forEach((item) => {
        const text = item.text || '';
        const href = getSearchPageUrl(text);
        html += `
          <li>
            <a class="flamingo-header__search-suggestion" href="${escapeHtml(href)}">
              <svg aria-hidden="true" viewBox="0 0 24 24" focusable="false">
                <circle cx="11" cy="11" r="6.5" fill="none" stroke="currentColor" stroke-width="1.4" />
                <path d="M16.2 16.2 20.5 20.5" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
              </svg>
              <span>${escapeHtml(text)}</span>
            </a>
          </li>
        `;
      });
      html += `</ul></div>`;
    }

    if (products.length) {
      html += `<div class="flamingo-header__search-group">`;
      html += `<p class="flamingo-header__search-group-title">${escapeHtml(productsLabel)}</p>`;
      html += `<ul class="flamingo-header__search-products">`;
      products.slice(0, 4).forEach((product) => {
        const title = product.title || '';
        const url = product.url || '#';
        const image = product.featured_image;
        const imageUrl = image && image.url
          ? `${image.url}${image.url.includes('?') ? '&' : '?'}width=160`
          : '';
        const priceValue = product.price_min != null ? product.price_min : product.price;
        const price = priceValue != null ? formatMoney(priceValue, moneyFormat) : '';

        html += `
          <li>
            <a class="flamingo-header__search-product" href="${escapeHtml(url)}">
              <span class="flamingo-header__search-product-media">
                ${
                  imageUrl
                    ? `<img src="${escapeHtml(imageUrl)}" alt="" width="64" height="64" loading="lazy">`
                    : `<span class="flamingo-header__search-product-placeholder" aria-hidden="true"></span>`
                }
              </span>
              <span class="flamingo-header__search-product-meta">
                <span class="flamingo-header__search-product-title">${escapeHtml(title)}</span>
                ${price ? `<span class="flamingo-header__search-product-price">${escapeHtml(price)}</span>` : ''}
              </span>
            </a>
          </li>
        `;
      });
      html += `</ul></div>`;
    }

    html += `
      <a class="flamingo-header__search-view-all" href="${escapeHtml(getSearchPageUrl(query))}">
        ${escapeHtml(viewAllLabel)}
        <span aria-hidden="true">→</span>
      </a>
    `;

    searchResults.innerHTML = html;
    searchResults.hidden = false;
    if (searchHint) searchHint.hidden = true;
  };

  const fetchPredictiveResults = (query) => {
    if (!searchPanel) return;

    const trimmed = query.trim();
    if (trimmed.length < 2) {
      clearSearchResults();
      return;
    }

    if (searchAbortController) searchAbortController.abort();
    searchAbortController = new AbortController();
    const requestId = ++activeSuggestRequest;

    const suggestBase = searchPanel.dataset.suggestUrl || '/search/suggest.json';
    const url = new URL(suggestBase, window.location.origin);
    url.searchParams.set('q', trimmed);
    url.searchParams.set('resources[type]', 'product,query');
    url.searchParams.set('resources[limit]', '6');
    url.searchParams.set('resources[limit_scope]', 'each');
    url.searchParams.set('resources[options][unavailable_products]', 'last');

    fetch(url.toString(), {
      signal: searchAbortController.signal,
      headers: { Accept: 'application/json' },
    })
      .then((response) => {
        if (!response.ok) throw new Error(String(response.status));
        return response.json();
      })
      .then((data) => {
        if (requestId !== activeSuggestRequest) return;
        renderPredictiveResults(data, trimmed);
      })
      .catch((error) => {
        if (error.name === 'AbortError') return;
        clearSearchResults();
      });
  };

  const schedulePredictiveSearch = () => {
    updateClearVisibility();
    window.clearTimeout(searchDebounceTimer);
    searchDebounceTimer = window.setTimeout(() => {
      if (!searchInput) return;
      fetchPredictiveResults(searchInput.value);
    }, 220);
  };

  const setSearchOpen = (isOpen) => {
    if (!header || !searchToggle || !searchPanel) return;

    header.classList.toggle('flamingo-header--search-open', isOpen);
    searchToggle.setAttribute('aria-expanded', String(isOpen));
    searchToggle.setAttribute(
      'aria-label',
      isOpen ? searchToggle.dataset.closeLabel : searchToggle.dataset.openLabel
    );
    searchPanel.hidden = !isOpen;

    if (searchBackdrop) {
      searchBackdrop.hidden = !isOpen;
    }

    if (isOpen) {
      closeDropdowns();

      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        header.classList.remove('flamingo-header--open');
        document.documentElement.classList.remove('flamingo-menu-lock');
      }

      header.classList.remove('flamingo-header--hidden');
      document.documentElement.classList.add('flamingo-search-lock');
      updateClearVisibility();
      window.requestAnimationFrame(() => {
        if (searchInput) {
          searchInput.focus();
          if (searchInput.value.trim().length >= 2) {
            fetchPredictiveResults(searchInput.value);
          }
        }
      });
    } else {
      document.documentElement.classList.remove('flamingo-search-lock');
      if (searchAbortController) searchAbortController.abort();
      window.clearTimeout(searchDebounceTimer);
    }
  };

  if (toggle) {
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') == 'true';
      const willOpen = !expanded;
      toggle.setAttribute('aria-expanded', String(willOpen));
      header.classList.toggle('flamingo-header--open', willOpen);
      if (willOpen) {
        closeDropdowns();
        setSearchOpen(false);
        document.documentElement.classList.add('flamingo-menu-lock');
      } else {
        document.documentElement.classList.remove('flamingo-menu-lock');
      }
    });
  }

  if (searchToggle) {
    searchToggle.addEventListener('click', () => {
      const isOpen = searchToggle.getAttribute('aria-expanded') === 'true';
      setSearchOpen(!isOpen);
    });
  }

  if (searchBackdrop) {
    searchBackdrop.addEventListener('click', () => setSearchOpen(false));
  }

  if (searchInput) {
    searchInput.addEventListener('input', schedulePredictiveSearch);
    searchInput.addEventListener('search', schedulePredictiveSearch);
  }

  if (searchClear) {
    searchClear.addEventListener('click', () => {
      resetSearchPanel();
      if (searchInput) searchInput.focus();
    });
  }

  if (header) {
    const scrollThreshold = 8;
    const hideAfter = 72;
    let lastScrollY = 0;
    let headerScrollTicking = false;

    const getScrollY = () => {
      if (window.FlamingoLenis && typeof window.FlamingoLenis.scroll === 'number') {
        return window.FlamingoLenis.scroll;
      }

      return window.scrollY;
    };

    const syncHeaderHeight = () => {
      header.style.setProperty('--flamingo-header-measured-height', `${header.offsetHeight}px`);
    };

    const setHeaderHidden = (isHidden) => {
      if (isHidden && header.classList.contains('flamingo-header--search-open')) return;

      header.classList.toggle('flamingo-header--hidden', isHidden);

      if (isHidden) {
        closeDropdowns();
        setSearchOpen(false);

        if (toggle) {
          toggle.setAttribute('aria-expanded', 'false');
          header.classList.remove('flamingo-header--open');
          document.documentElement.classList.remove('flamingo-menu-lock');
        }
      }
    };

    const updateHeaderOnScroll = () => {
      headerScrollTicking = false;
      const currentScrollY = Math.max(0, getScrollY());

      if (header.classList.contains('flamingo-header--open') || header.classList.contains('flamingo-header--search-open')) {
        lastScrollY = currentScrollY;
        return;
      }

      if (currentScrollY <= 0) {
        setHeaderHidden(false);
        lastScrollY = currentScrollY;
        return;
      }

      const delta = currentScrollY - lastScrollY;

      if (delta > scrollThreshold && currentScrollY > hideAfter) {
        setHeaderHidden(true);
      } else if (delta < -scrollThreshold) {
        setHeaderHidden(false);
      }

      lastScrollY = currentScrollY;
    };

    const scheduleHeaderScrollUpdate = () => {
      if (headerScrollTicking) return;
      headerScrollTicking = true;
      window.requestAnimationFrame(updateHeaderOnScroll);
    };

    const bindHeaderScrollListeners = () => {
      window.addEventListener('scroll', scheduleHeaderScrollUpdate, { passive: true });
      window.addEventListener('resize', () => {
        syncHeaderHeight();
        scheduleHeaderScrollUpdate();
      });

      if (window.FlamingoLenis) {
        window.FlamingoLenis.on('scroll', scheduleHeaderScrollUpdate);
        return;
      }

      const waitForLenis = window.setInterval(() => {
        if (!window.FlamingoLenis) return;

        window.FlamingoLenis.on('scroll', scheduleHeaderScrollUpdate);
        window.clearInterval(waitForLenis);
      }, 50);

      window.setTimeout(() => window.clearInterval(waitForLenis), 10000);
    };

    syncHeaderHeight();
    updateHeaderOnScroll();
    bindHeaderScrollListeners();
    window.addEventListener('load', syncHeaderHeight);
  }

  dropdowns.forEach((dropdown) => {
    dropdown.addEventListener('toggle', () => {
      if (dropdown.open) {
        closeDropdowns(dropdown);
        setSearchOpen(false);
      }
    });

    // `toggle` fires asynchronously, so close the others synchronously the
    // moment a closed dropdown is about to open — never two open at once.
    const summary = dropdown.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', () => {
        if (!dropdown.open) closeDropdowns(dropdown);
      });
    }
  });

  document.addEventListener('click', (event) => {
    if (!header || header.contains(event.target)) return;

    closeDropdowns();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    closeDropdowns();
    setSearchOpen(false);

    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      header.classList.remove('flamingo-header--open');
      document.documentElement.classList.remove('flamingo-menu-lock');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!customElements.get('product-recommendations')) {
      customElements.define(
        'product-recommendations',
        class ProductRecommendations extends HTMLElement {
          connectedCallback() {
            if (this.dataset.loaded === '1') return;
            this.dataset.loaded = '1';

            const load = () => {
              fetch(`${this.dataset.url}&product_id=${this.dataset.productId}&section_id=${this.dataset.sectionId}`)
                .then((response) => response.text())
                .then((text) => {
                  const html = document.createElement('div');
                  html.innerHTML = text;
                  const recommendations = html.querySelector('product-recommendations');

                  if (recommendations && recommendations.innerHTML.trim()) {
                    this.innerHTML = recommendations.innerHTML;
                    return;
                  }

                  this.remove();
                })
                .catch(() => {
                  this.remove();
                });
            };

            load();
          }
        }
      );
    }

    const sections = document.querySelectorAll('.flamingo-pdp');
    sections.forEach((section) => {
      if (section.dataset.bound === '1') return;
      section.dataset.bound = '1';

      // Variant data
      const variantsScript = document.querySelector(
        `[data-pdp-variants][data-section="${section.dataset.sectionId}"]`
      );
      let variants = [];
      if (variantsScript) {
        try { variants = JSON.parse(variantsScript.textContent); } catch (e) { variants = []; }
      }

      const idInput = section.querySelector('[data-pdp-variant-id]');
      const priceEl = section.querySelector('[data-pdp-price]');
      const addBtn = section.querySelector('[data-pdp-add]');
      const buyBtn = section.querySelector('[data-pdp-buy]');
      const addLabel = section.querySelector('[data-pdp-add-label]');
      const viewport = section.querySelector('[data-pdp-viewport]');
      const galleryTrack = section.querySelector('[data-pdp-track]');
      const prevBtn = section.querySelector('[data-pdp-prev]');
      const nextBtn = section.querySelector('[data-pdp-next]');
      const galleryNav = section.querySelector('[data-pdp-gallery-nav]');
      let programmaticSlide = null;
      const optGroups = Array.from(section.querySelectorAll('.flamingo-pdp__opt-group'));
      const accordions = section.querySelectorAll('.flamingo-pdp__accordion');

      function normalizeMoneyDisplay(value) {
        return String(value || '');
      }

      function moneyFormat(cents) {
        const amount = Number(cents || 0);
        const defaultFormat = '₹ ' + '{' + '{amount_no_decimals}' + '}';
        const format = section.dataset.moneyFormat || defaultFormat;

        if (window.Shopify && typeof Shopify.formatMoney === 'function') {
          return normalizeMoneyDisplay(Shopify.formatMoney(amount, format));
        }

        const value = amount / 100;
        const formatWithDelimiters = (number, decimals) =>
          Number(number).toLocaleString('en-IN', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
          });

        return normalizeMoneyDisplay(
          format
            .replace(/[{][{][ ]*amount_no_decimals[ ]*[}][}]/g, formatWithDelimiters(value, 0))
            .replace(/[{][{][ ]*amount[ ]*[}][}]/g, formatWithDelimiters(value, 2))
            .replace(/[{][{][ ]*amount_with_comma_separator[ ]*[}][}]/g, formatWithDelimiters(value, 2))
        );
      }

      function selectedOptions() {
        return optGroups.map((group) => {
          const checked = group.querySelector('.flamingo-pdp__pill-input:checked');
          return checked ? checked.value : null;
        });
      }

      function findMatchingVariant() {
        const chosen = selectedOptions();
        return variants.find((v) =>
          v.options.every((opt, i) => opt === chosen[i])
        );
      }

      function variantImageId(variant) {
        return variant && variant.featured_image && variant.featured_image.id
          ? String(variant.featured_image.id)
          : '';
      }

      function getSlides() {
        return Array.from(section.querySelectorAll('[data-pdp-slide]'));
      }

      function getVisibleSlides() {
        return getSlides().filter((slide) => !slide.hidden);
      }

      function setActiveSlide(slide) {
        if (!slide) return;
        getSlides().forEach((item) => {
          item.classList.toggle('is-active', item === slide);
        });
      }

      function updateStaticMode() {
        if (!viewport) return;
        const isStatic = getVisibleSlides().length < 2;
        viewport.classList.toggle('is-static', isStatic);

        if (galleryNav) galleryNav.hidden = isStatic;
        if (prevBtn) prevBtn.disabled = isStatic;
        if (nextBtn) nextBtn.disabled = isStatic;
        syncGalleryEndPadding();
      }

      function syncGalleryEndPadding() {
        if (!viewport || !galleryTrack) return;

        galleryTrack.style.paddingRight = '0px';
        const visible = getVisibleSlides();
        if (visible.length < 2) return;

        const lastSlide = visible[visible.length - 1];
        const endPadding = Math.max(
          0,
          viewport.clientWidth - lastSlide.getBoundingClientRect().width
        );
        galleryTrack.style.paddingRight = `${Math.round(endPadding)}px`;
      }

      function getSlideTargetScrollLeft(slide) {
        // Align the slide's left edge with the viewport's left edge.
        const slideRect = slide.getBoundingClientRect();
        const viewportRect = viewport.getBoundingClientRect();
        return viewport.scrollLeft + (slideRect.left - viewportRect.left);
      }

      function scrollToSlide(slide, behavior) {
        if (!viewport || !slide) return;

        const targetLeft = getSlideTargetScrollLeft(slide);
        const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        programmaticSlide = slide;

        viewport.scrollTo({
          left: Math.max(0, Math.min(targetLeft, maxScroll)),
          behavior: behavior || 'smooth',
        });

        setActiveSlide(slide);
      }

      function getNearestSlide() {
        const visible = getVisibleSlides();
        if (!visible.length || !viewport) return null;

        const viewportLeft = viewport.getBoundingClientRect().left;
        let nearest = visible[0];
        let minDistance = Infinity;

        visible.forEach((slide) => {
          const distance = Math.abs(slide.getBoundingClientRect().left - viewportLeft);
          if (distance < minDistance) {
            minDistance = distance;
            nearest = slide;
          }
        });

        return nearest;
      }

      function navigateSlide(direction) {
        const visible = getVisibleSlides();
        if (visible.length < 2) return;

        const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        const stops = [];

        for (const slide of visible) {
          const targetLeft = Math.max(
            0,
            Math.min(getSlideTargetScrollLeft(slide), maxScroll)
          );
          const previousStop = stops[stops.length - 1];

          if (previousStop && Math.abs(previousStop.left - targetLeft) < 1) {
            previousStop.slide = slide;
          } else {
            stops.push({ slide, left: targetLeft });
          }
        }

        if (stops.length < 2) return;

        let currentIndex = 0;
        let currentDistance = Infinity;
        for (let index = 0; index < stops.length; index += 1) {
          const distance = Math.abs(stops[index].left - viewport.scrollLeft);
          if (distance < currentDistance) {
            currentDistance = distance;
            currentIndex = index;
          }
        }

        const nextIndex = (currentIndex + direction + stops.length) % stops.length;
        scrollToSlide(stops[nextIndex].slide);
      }

      function updateActiveThumb(imageId) {
        const visible = getVisibleSlides();
        if (!visible.length) return;

        const preferred = visible.find(
          (slide) => slide.dataset.imageId === String(imageId)
        );
        scrollToSlide(preferred || visible[0], 'auto');
      }

      function updateGalleryForVariant(variant) {
        for (const slide of getSlides()) {
          slide.hidden = false;
        }

        updateStaticMode();
        updateActiveThumb(variantImageId(variant));
      }

      function updateUI(variant) {
        if (!variant) {
          if (addBtn) addBtn.disabled = true;
          if (buyBtn) buyBtn.disabled = true;
          if (addLabel) addLabel.textContent = 'Unavailable';
          return;
        }

        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.textContent = moneyFormat(variant.price);
        var fxEl = section.querySelector('[data-fx-cents]');
        if (fxEl && window.FlamingoCurrency) window.FlamingoCurrency.update(fxEl, variant.price);
        if (addBtn) addBtn.disabled = !variant.available;
        if (buyBtn) buyBtn.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';

        updateGalleryForVariant(variant);

        // Update URL with variant id
        if (window.history && window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      optGroups.forEach((group) => {
        group.querySelectorAll('.flamingo-pdp__pill').forEach((pill) => {
          const input = pill.querySelector('.flamingo-pdp__pill-input');
          if (!input) return;
          input.addEventListener('change', () => {
            group.querySelectorAll('.flamingo-pdp__pill').forEach((p) => p.classList.remove('is-active'));
            pill.classList.add('is-active');
            updateUI(findMatchingVariant());
          });
        });
      });

      // Description "Read more" toggle
      const description = section.querySelector('[data-pdp-description]');
      const readMore = section.querySelector('[data-pdp-readmore]');
      if (description && readMore) {
        if (description.scrollHeight <= description.clientHeight + 2) {
          readMore.style.display = 'none';
        }
        readMore.addEventListener('click', () => {
          const clamped = description.classList.toggle('is-clamped');
          readMore.textContent = clamped ? 'Read more' : 'Read less';
        });
      }

      accordions.forEach((accordion) => {
        accordion.addEventListener('toggle', () => {
          if (!accordion.open) return;

          accordions.forEach((otherAccordion) => {
            if (otherAccordion !== accordion) {
              otherAccordion.open = false;
            }
          });
        });
      });

      // Smooth-scroll the reviews link to the testimonials ("what our customers are saying") section
      const reviewsLink = section.querySelector('.flamingo-pdp__reviews');
      if (reviewsLink) {
        reviewsLink.addEventListener('click', (event) => {
          const target = document.getElementById('flamingo-pdp-reviews');
          if (target) {
            event.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }

      // Reviews slider — arrows + dots change the cards; centre card is highlighted
      const reviewsTrack = section.querySelector('[data-pdp-reviews-track]');
      const reviewOriginals = reviewsTrack
        ? Array.from(reviewsTrack.querySelectorAll('[data-pdp-review]'))
        : [];
      if (reviewsTrack && reviewOriginals.length) {
        const reviewsSlider =
          reviewsTrack.closest('.flamingo-pdp__reviews-slider') || reviewsTrack.parentElement;
        const reviewsPrev = section.querySelector('[data-pdp-reviews-prev]');
        const reviewsNext = section.querySelector('[data-pdp-reviews-next]');
        const reviewsDots = section.querySelector('[data-pdp-reviews-dots]');
        const reviewCount = reviewOriginals.length;
        const looped = reviewCount > 1;

        // Clone a full set before and after the originals so any review can sit
        // dead-centre with neighbours on both sides, and the rotation wraps
        // seamlessly in either direction.
        function cloneReview(el) {
          const c = el.cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          c.setAttribute('data-pdp-review-clone', '');
          c.querySelectorAll('a, button').forEach((x) => x.setAttribute('tabindex', '-1'));
          return c;
        }
        if (looped && reviewsTrack.dataset.reviewsLooped !== '1') {
          reviewsTrack.dataset.reviewsLooped = '1';
          const leadFrag = document.createDocumentFragment();
          const trailFrag = document.createDocumentFragment();
          reviewOriginals.forEach((el) => leadFrag.appendChild(cloneReview(el)));
          reviewOriginals.forEach((el) => trailFrag.appendChild(cloneReview(el)));
          reviewsTrack.insertBefore(leadFrag, reviewOriginals[0]);
          reviewsTrack.appendChild(trailFrag);
        }

        const reviewCards = Array.from(reviewsTrack.children);
        const base = looped ? reviewCount : 0; // DOM index of the first canonical card
        let realPos = base; // DOM index of the currently centred card

        function centreOffset(pos) {
          const gap = parseFloat(getComputedStyle(reviewsTrack).columnGap || '0') || 0;
          const cardW = reviewCards[0].getBoundingClientRect().width;
          const step = cardW + gap;
          return reviewsSlider.clientWidth / 2 - (pos * step + cardW / 2);
        }

        const activeIndex = () => ((realPos - base) % reviewCount + reviewCount) % reviewCount;

        function paint() {
          reviewCards.forEach((card, i) => card.classList.toggle('is-center', i === realPos));
          if (reviewsDots) {
            const a = activeIndex();
            Array.from(reviewsDots.children).forEach((dot, i) => {
              dot.classList.toggle('is-active', i === a);
            });
          }
        }

        function render(animate) {
          paint();
          reviewsTrack.style.transition = animate ? '' : 'none';
          reviewsTrack.style.transform = 'translateX(' + centreOffset(realPos) + 'px)';
          if (!animate) {
            // Force reflow so subsequent changes animate again.
            void reviewsTrack.offsetWidth;
            reviewsTrack.style.transition = '';
          }
        }

        // After sliding into the cloned region, snap back to the identical
        // canonical card without animation (no visible jump).
        reviewsTrack.addEventListener('transitionend', (e) => {
          if (e.target !== reviewsTrack || e.propertyName !== 'transform' || !looped) return;
          let snap = false;
          while (realPos < base) { realPos += reviewCount; snap = true; }
          while (realPos >= base + reviewCount) { realPos -= reviewCount; snap = true; }
          if (snap) render(false);
        });

        function go(delta) {
          realPos += delta;
          render(true);
        }

        if (reviewsPrev) reviewsPrev.addEventListener('click', () => go(-1));
        if (reviewsNext) reviewsNext.addEventListener('click', () => go(1));

        function buildReviewDots() {
          if (!reviewsDots) return;
          reviewsDots.innerHTML = '';
          // One dot per review (total number of reviews).
          for (let i = 0; i < reviewCount; i++) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'flamingo-pdp__reviews-dot';
            dot.setAttribute('aria-label', 'Go to review ' + (i + 1));
            dot.addEventListener('click', () => {
              // Slide to the copy of review i nearest the current position.
              const candidates = looped ? [i, i + reviewCount, i + 2 * reviewCount] : [i];
              let best = candidates[0];
              candidates.forEach((c) => {
                if (Math.abs(c - realPos) < Math.abs(best - realPos)) best = c;
              });
              realPos = best;
              render(true);
            });
            reviewsDots.appendChild(dot);
          }
        }

        const singleReview = reviewCount <= 1;
        if (reviewsPrev) reviewsPrev.disabled = singleReview;
        if (reviewsNext) reviewsNext.disabled = singleReview;

        let reviewResizeTimer;
        window.addEventListener('resize', () => {
          window.clearTimeout(reviewResizeTimer);
          reviewResizeTimer = window.setTimeout(() => { render(false); }, 150);
        });

        buildReviewDots();
        // Defer to after first paint so card widths are available.
        requestAnimationFrame(() => { render(false); });
      }

      // Keep the description/details centered while this product grid is in
      // view. The grid itself bounds the sticky element, so it releases before
      // the following section. The right column remains part of the page scroll.
      const pdpBody = section.querySelector('.flamingo-pdp__body');
      const pdpHeroRight = section.querySelector('.flamingo-pdp__hero-right');
      if (pdpBody) {
        const pdpDesktop = window.matchMedia('(min-width: 901px)');
        const syncStickyPosition = () => {
          if (!pdpDesktop.matches) {
            pdpBody.style.removeProperty('--pdp-sticky-top');
            return;
          }

          const viewportEdge = 24;
          const bodyHeight = pdpBody.getBoundingClientRect().height;
          const centeredTop = (window.innerHeight - bodyHeight) / 2;
          pdpBody.style.setProperty(
            '--pdp-sticky-top',
            `${Math.round(Math.max(viewportEdge, centeredTop))}px`
          );
        };

        if (pdpHeroRight) {
          pdpHeroRight.style.removeProperty('max-height');
          pdpHeroRight.style.removeProperty('overflow-y');
          pdpHeroRight.style.removeProperty('overflow-x');
        }

        syncStickyPosition();
        requestAnimationFrame(syncStickyPosition);
        window.addEventListener('load', syncStickyPosition);

        let pdpStickyTimer;
        window.addEventListener('resize', () => {
          window.clearTimeout(pdpStickyTimer);
          pdpStickyTimer = window.setTimeout(syncStickyPosition, 150);
        });

        if ('ResizeObserver' in window) {
          const pdpStickyObserver = new ResizeObserver(syncStickyPosition);
          pdpStickyObserver.observe(pdpBody);
        }
      }

      // ---- Product image gallery ------------------------------------------
      // Keep one canonical DOM slide per product image. Native scrolling
      // handles touch swipes, mouse dragging snaps to the nearest image, and
      // arrow/keyboard navigation wraps through the visible image list.
      const dragState = { pointerId: null, startX: 0, startScroll: 0, active: false };
      let snapRestorePending = false;

      if (viewport) {
        let scrollTimeout;
        viewport.addEventListener(
          'scroll',
          () => {
            window.clearTimeout(scrollTimeout);
            scrollTimeout = window.setTimeout(() => {
              if (snapRestorePending && !dragState.active) {
                snapRestorePending = false;
                viewport.style.scrollSnapType = '';
              }

              const settledSlide = programmaticSlide || getNearestSlide();
              programmaticSlide = null;
              if (settledSlide) setActiveSlide(settledSlide);
            }, 100);
          },
          { passive: true }
        );

        viewport.addEventListener('keydown', (event) => {
          if (viewport.classList.contains('is-static')) return;

          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            navigateSlide(-1);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            navigateSlide(1);
          }
        });

        // Mouse drag-to-scroll (touch devices already pan the scroller
        // natively). Snap is disabled while dragging so the track follows the
        // cursor 1:1, then we snap to the nearest slide on release.
        viewport.addEventListener('pointerdown', (event) => {
          programmaticSlide = null;
          if (viewport.classList.contains('is-static')) return;
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          dragState.pointerId = event.pointerId;
          dragState.startX = event.clientX;
          dragState.startScroll = viewport.scrollLeft;
          dragState.active = false;
        });

        viewport.addEventListener('pointermove', (event) => {
          if (dragState.pointerId !== event.pointerId) return;
          const dx = event.clientX - dragState.startX;
          if (!dragState.active) {
            if (Math.abs(dx) < 5) return;
            dragState.active = true;
            try { viewport.setPointerCapture(dragState.pointerId); } catch (e) { /* no-op */ }
            viewport.classList.add('is-dragging');
            viewport.style.scrollSnapType = 'none';
            viewport.style.scrollBehavior = 'auto';
          }
          viewport.scrollLeft = dragState.startScroll - dx;
        });

        const endDrag = (event) => {
          if (dragState.pointerId !== event.pointerId) return;
          const wasDragging = dragState.active;
          dragState.pointerId = null;
          dragState.active = false;
          viewport.classList.remove('is-dragging');
          viewport.style.scrollBehavior = '';

          if (!wasDragging) {
            viewport.style.scrollSnapType = '';
            return;
          }

          const nearest = getNearestSlide();
          if (!nearest) {
            viewport.style.scrollSnapType = '';
            return;
          }

          const target = getSlideTargetScrollLeft(nearest);
          if (Math.abs(target - viewport.scrollLeft) < 1) {
            viewport.style.scrollSnapType = '';
            setActiveSlide(nearest);
          } else {
            // Restore snap only after the settle scroll finishes, otherwise
            // the browser re-snaps with a visible jump.
            snapRestorePending = true;
            scrollToSlide(nearest);
          }
        };

        viewport.addEventListener('pointerup', endDrag);
        viewport.addEventListener('pointercancel', endDrag);
        viewport.addEventListener('wheel', () => {
          programmaticSlide = null;
        }, { passive: true });
        viewport.addEventListener('dragstart', (event) => event.preventDefault());

        const realignActiveSlide = () => {
          const activeSlide =
            getVisibleSlides().find((slide) => slide.classList.contains('is-active')) ||
            getVisibleSlides()[0];
          syncGalleryEndPadding();
          if (activeSlide) scrollToSlide(activeSlide, 'auto');
        };

        if ('ResizeObserver' in window) {
          const galleryResizeObserver = new ResizeObserver(realignActiveSlide);
          galleryResizeObserver.observe(viewport);
        } else {
          window.addEventListener('resize', realignActiveSlide);
        }
      }

      if (prevBtn) prevBtn.addEventListener('click', () => navigateSlide(-1));
      if (nextBtn) nextBtn.addEventListener('click', () => navigateSlide(1));

      updateStaticMode();

      const initialSlide =
        getSlides().find((slide) => slide.classList.contains('is-active')) || getSlides()[0];
      if (initialSlide && viewport) {
        requestAnimationFrame(() => {
          // Use an instant initial alignment so the selected variant image is
          // in place before the customer interacts with the gallery.
          const prevBehavior = viewport.style.scrollBehavior;
          viewport.style.scrollBehavior = 'auto';
          scrollToSlide(initialSlide, 'auto');
          viewport.style.scrollBehavior = prevBehavior;
        });
      }

      updateGalleryForVariant(findMatchingVariant());

      // Buy now — submit the form with return_to=/checkout
      if (buyBtn) {
        buyBtn.addEventListener('click', (e) => {
          e.preventDefault();
          if (buyBtn.disabled) return;
          if (typeof window.handleFloBuyNowBtn === 'function') {
            window.handleFloBuyNowBtn(e);
            return;
          }
          const form = section.querySelector('form');
          if (!form) return;
          let returnInput = form.querySelector('input[name="return_to"]');
          if (!returnInput) {
            returnInput = document.createElement('input');
            returnInput.type = 'hidden';
            returnInput.name = 'return_to';
            form.appendChild(returnInput);
          }
          returnInput.value = '/checkout';
          form.submit();
        });
      }

    });
  })();

  } catch(e) { console.error(e); }
})();
})();
